import { isString } from "lodash";
export function isKeyOf(value, obj) {
    return !!value && Object.keys(obj).includes(value);
}
export { isString };
